const SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
const MOZ_HACK_REGEXP = /^moz([A-Z])/;

// 转驼峰
const camelCase = function(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};

// 绑定事件
export const on = (function() {
  if (process.server) return;

  if (document.addEventListener) {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
})();

// 卸载事件
export const off = (function() {
  if (process.server) return;

  if (document.removeEventListener) {
    return function(element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function(element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
})();

// 绑定一次性事件
export const once = function(el, event, fn) {
  if (process.server) return;

  let listener = function() {
    if (fn) {
      fn.apply(this, arguments);
    }

    off(el, event, listener);
  };

  on(el, event, listener);
};

// 判断是否存在class
export function hasClass(el, cls) {
  if (process.server) return;

  if (!el || !cls) return false;

  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');

  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
};

// 添加class
export function addClass(el, cls) {
  if (process.server) return;

  if (!el) return;

  let curClass = el.className;
  let classes = (cls || '').split(' ');

  for (let i = 0, j = classes.length; i < j; i++) {
    let clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName;
    }
  }

  if (!el.classList) {
    el.className = curClass;
  }
};

// 移除class
export function removeClass(el, cls) {
  if (process.server) return;

  if (!el || !cls) return;

  const classes = cls.split(' ');
  let curClass = ' ' + el.className + ' ';

  for (let i = 0, j = classes.length; i < j; i++) {
    let clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ');
    }
  }

  if (!el.classList) {
    el.className = trim(curClass);
  }
};

// 安全的获取dom
export const getDom = (ele) => {
  if (ele instanceof HTMLElement) {
    return ele;
  }

  return null;
};

// 添加子元素
export const append = (parentId, child) => {
  let parent = document.getElementById(parentId);

  if (!parent) {
    parent = getDom(parentId);
  }

  if (parent) {
    parent.appendChild(child);
  }
};

// 获取样式
export const getStyle = function(element, styleName) {
  if (process.server) return;

  if (!element || !styleName) return null;

  styleName = camelCase(styleName);

  if (styleName === 'float') {
    styleName = 'cssFloat';
  }

  try {
    let computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};

// 设置样式
export function setStyle(element, styleName, value) {
  if (process.server) return;
  if (!element || !styleName) return;

  if (typeof styleName === 'object') {
    for (let prop in styleName) {
      if (styleName.hasOwnProperty(prop)) {
        setStyle(element, prop, styleName[prop]);
      }
    }
  } else {
    styleName = camelCase(styleName);
    element.style[styleName] = value;
  }
};

// 显示元素
export function showEle(element) {
  setStyle(element, 'display', 'block');
};

// 隐藏元素
export function hideEle(element) {
  setStyle(element, 'display', 'none');
};

// 创建元素
export const createEle = (eleName, style) => {
  if (process.server) return;
  let ele = document.createElement(eleName);
  if (style) {
    setStyle(ele, style);
  }
  return ele;
};

// canvas转img
export const createImgFromCanvas = (canvas, style) => {
  if (process.server) return;

  let img = document.createElement('img');
  img.src = canvas.toDataURL('image/png');

  if (style) {
    setStyle(img, style);
  }

  return img;
};

// 创建img元素
export const createImgFromSrc = (src, style, event) => {
  if (process.server) return;

  let img = document.createElement('img');
  img.src = src;

  if (style) {
    setStyle(img, style);
  }

  if (!!event && !!event.click) {
    img.onclick = event.click;
  }

  return img;
};

// 获取scrollTop
export const getScrollTop = () => {
  if (document.body.scrollTop != 0) {
    return {
      top: document.body.scrollTop,
      dom: document.body
    }
  }

  if (document.documentElement.scrollTop != 0) {
    return {
      top: document.documentElement.scrollTop,
      dom: document.documentElement
    }
  }

  return {
    top: 0,
    dom: null
  }
};

// 绘制canvas
export const drawCanvas = function(options) {
  if (process.server) return;

  // 设置body滚动至顶部
  let topInfo = getScrollTop();

  if (topInfo.top != 0 && topInfo.dom != null) {
    topInfo.dom.scrollTop = 0;
  }

  let containId = options.containId,
      bgColor = options.bgColor;

  // 获取想要转换的 DOM 节点
  let dom = document.getElementById(containId);
  let box = window.getComputedStyle(dom);

  // DOM 节点计算后宽高
  let width = parseInt(box.width);
  let height = parseInt(box.height);

  // 获取像素比
  const scaleBy = window.devicePixelRatio;

  // 创建自定义 canvas 元素
  let canvas = document.createElement('canvas');
  canvas.setAttribute('id', 'captureCanvas');

  // 设定canvas元素属性宽高为 DOM 节点宽高 * 像素比
  canvas.width = width * scaleBy;
  canvas.height = height * scaleBy;

  // 设定canvas的css宽高为DOM节点宽高
  canvas.style.width = `${width}px`;
  canvas.style.height = `${height}px`;

  // 获取画笔
  let context = canvas.getContext('2d');

  // 将所有绘制内容放大像素比倍
  context.scale(scaleBy/2, scaleBy/2);

  let html2canvas = require('html2canvas');

  // 将自定义 canvas 作为配置项传入，开始绘制
  let c = html2canvas(dom, {
    canvas: canvas,
    scale: 2,
    useCORS: true,
    allowTaint: true,
    useCORS: true,
    backgroundColor: bgColor
  });

  // 将body滚动至原来的位置
  if (topInfo.top != 0 && topInfo.dom != null) {
    topInfo.dom.scrollTop = topInfo.top;
  }

  return c;
};

// 添加touchStart监听事件
export const addTouchStart = (options) => {
  options.el.addEventListener('touchstart', options.fn);
};

// 添加touchEnd监听事件
export const addTouchEnd = (options) => {
  options.el.addEventListener('touchend', options.fn);
};

// 移动窗体到指定位置
export const scrollIntoView = (id) => {
  let formID = document.getElementById(id);

  if (!!formID) {
    formID.scrollIntoView({
          behavior:"smooth",
          block:"center",
          inline:"center"
      });
  }else {
    console.log("该元素没有找到:",id)
  }
}
